module.exports = __webpack_public_path__ + "static/img/major_profile_1080x1076.b2af7b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_profile_1080x1076.jpg
// module id = nifC
// module chunks = 0